var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quizier-module module-cta-form"},[_c('form-module',{attrs:{"block_id":_vm.block_id,"post_id":_vm.postID,"data":_vm.form_data},on:{"lead-captured":_vm.leadCaptured}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }